import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { TrackComponent } from '@eliadmin/core/src/components/analytics/analytics-helpers';
import {
  ProductCard,
  type ProductCardProps,
} from '@eliadmin/core/src/components/product/product-card';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

export type ProductsGridProps = {
  products: Product[];
  className?: {
    wrapper?: string;
    product?: ProductCardProps['className'];
  };
};
export function ProductsGrid(props: ProductsGridProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-x-3 gap-y-6 sm:grid-cols-2 sm:gap-y-8 md:grid-cols-3 md:gap-x-4 lg:grid-cols-4 xl:gap-x-6',
        'ea-product-list',
        props.className?.wrapper,
      )}
    >
      <TrackComponent
        eventName={'view_item_list'}
        items={props.products.flatMap(product => {
          const priceDisplay = getProductPriceDisplay(product);
          if (priceDisplay.priceOnRequest || priceDisplay.currentWithVat == null) return [];

          return [
            {
              item_id: product.code,
              item_name: product.name,
              price: priceDisplay.currentWithVat,
              quantity: 1,
            },
          ];
        })}
      />
      {props.products.map(product => (
        <ProductCard key={product.id} product={product} className={props.className?.product} />
      ))}
    </div>
  );
}
